import { useState } from "react";
import { Link } from "react-router-dom";
import { testimonials } from "@/mocks/testimonials";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];
  const leftAnim = useScrollAnimation({ threshold: 0.1 });
  const rightAnim = useScrollAnimation({ threshold: 0.1, rootMargin: "0px 0px -60px 0px" });

  return (
    <section className="bg-[#faf8f5] py-20 md:py-28 overflow-hidden">
      <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div
            ref={leftAnim.ref as React.RefObject<HTMLDivElement>}
            className={`rounded-lg overflow-hidden aspect-[4/5] max-w-[480px] mx-auto lg:mx-0 w-full transition-all duration-900 ${leftAnim.isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}
          >
            <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top transition-opacity duration-500" />
          </div>

          {/* Right Content */}
          <div
            ref={rightAnim.ref as React.RefObject<HTMLDivElement>}
            className={`flex flex-col justify-center transition-all duration-900 delay-200 ${rightAnim.isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}
          >
            <p className="text-[#8B5E52] text-[1rem] tracking-[0.25em] uppercase font-medium mb-4">Customer Stories</p>
            <h2 className="text-[#3d2b1f] text-[2.125rem] md:text-[2.5rem] font-bold leading-[1.4] mb-2">顧客真實回饋</h2>
            <p className="text-[#7a6455] text-[1.1875rem] mb-8 leading-[1.75]">{t.highlight}</p>

            <div className="flex gap-1 mb-6">
              {Array.from({ length: t.rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-[#c9a98a] text-lg"></i>
              ))}
            </div>

            <blockquote className="text-[#3d2b1f] text-[1.1875rem] leading-[1.75] mb-4 border-l-4 border-[#c9a98a] pl-5 italic">
              「{t.comment}」
            </blockquote>
            <p className="text-[#8B5E52] text-[1.0625rem] font-semibold mb-1">— {t.location} {t.name}</p>
            <p className="text-[#a09080] text-[1rem]">購買：{t.purchasedItem}</p>

            <div className="flex items-center justify-between mt-8">
              <div className="flex items-center gap-3">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrent(i)}
                    className={`transition-all duration-300 rounded-full cursor-pointer ${i === current ? "w-8 h-3 bg-[#8B5E52]" : "w-3 h-3 bg-[#c9a98a]/50 hover:bg-[#c9a98a]"}`}
                  />
                ))}
              </div>
              <Link
                to="/reviews"
                className="inline-flex items-center gap-1.5 px-5 py-2.5 border border-[#8B5E52] text-[#8B5E52] rounded-full text-sm font-semibold hover:bg-[#8B5E52] hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                查看更多好評
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
